__turbopack_context__.v({
  "has_icon": "styles-module-scss-module__C5WFTq__has_icon",
  "tab": "styles-module-scss-module__C5WFTq__tab",
  "tab_container": "styles-module-scss-module__C5WFTq__tab_container",
  "tab_label": "styles-module-scss-module__C5WFTq__tab_label",
  "tabs": "styles-module-scss-module__C5WFTq__tabs",
  "theme_default": "styles-module-scss-module__C5WFTq__theme_default",
  "theme_pill": "styles-module-scss-module__C5WFTq__theme_pill",
  "theme_unified": "styles-module-scss-module__C5WFTq__theme_unified",
});
